import axios from 'axios';
const httpClient = axios.create({
	baseURL: '/apps3/cheque-order'
});

const init = () => httpClient.get('/health-check');
const sendForm = (data) => httpClient.post('/transfer-callback-form', data);
const captcha = () => httpClient.get('/captcha');

export const useTransferCallbackApi = () => ({
	init,
	sendForm,
	captcha
});
